import { Progress } from '@mantine/core';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { leftArrow } from '../../assets/svgs/leftArrow.svg';

import styles from "./ResearcheLoader.module.scss";

import NODISPO from "../../assets/png/research_loader/no_dispo.png";
import NORESULT from "../../assets/png/research_loader/no_result.png";
import Research10 from "../../assets/png/research_loader/research_10.png";
import Research20 from "../../assets/png/research_loader/research_20.png";
import Research40 from "../../assets/png/research_loader/research_30.png";
import Research50 from "../../assets/png/research_loader/research_40.png";
import Research70 from "../../assets/png/research_loader/research_70.png";
import Research80 from "../../assets/png/research_loader/research_80.png";

const loaderImgaesSrc: string[] = [
  Research10,
  Research20,
  Research40,
  Research50,
  Research70,
  Research80,
  NORESULT,
  NODISPO
];

const ResearchLoader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <article className={styles.research_loader_container}>
      <button
        onClick={() => {
          navigate(-1);
        }}
      >
        {leftArrow}
        {t("researchLoader.back")}
      </button>
      <div>
        <h1>{t("researchLoader.searchingEstablishments")}</h1>
        <img src={loaderImgaesSrc[0]} alt="loader" />
        <p>14%</p>
        <Progress className={styles.loader} color="#003E5C" value={14} />
      </div>
    </article>
  );
};

export default ResearchLoader;